
import React from "react";
import { MessageCircle } from "lucide-react";
import { isBrowser } from "@/utils/runtime";

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    if (isBrowser) {
      globalThis.open("https://wa.me/554797367396?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20os%20serviços%20de%20fotografia%20para%20imóveis.", "_blank");
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={handleWhatsAppClick}
        className="bg-[#25D366] text-white rounded-full p-4 shadow-lg hover:bg-[#20ba57] transition-colors"
        aria-label="Entrar em contato via WhatsApp"
        suppressHydrationWarning
      >
        <MessageCircle size={24} />
      </button>
    </div>
  );
};

export default WhatsAppButton;
